import React, { useContext, useRef, useState } from 'react';
import { BsBookmarkFill } from 'react-icons/bs';
import { FaRegBookmark } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { deleteBookmark, createBookmark } from '../../../actions/feeds_actions_new';
import { feedActionContext } from '../..';
import { catchErr, userInfo } from '../../../../libs/HelperContent';

interface Props {
    feedId: string;
    isBookmarked: boolean;
    addBookMarkCallback?: () => void;
    disabled?: boolean;
}

const BookMarkButton = (props: Props) =>
{
	const stopRef = useRef(false);
	const userData = useSelector((state: any) => state.mysession.session);

	// Props destructuring
	const {
		feedId,
		isBookmarked = false,
		addBookMarkCallback = () => {},
		disabled = false
	} = props;

	// State management for bookmark status
	const [ bookMark, setBookMark ] = useState<boolean>(isBookmarked);

	// Context for handling feed actions
	const { handleFeedAction } = useContext(feedActionContext);

	// Query object for API calls
	const query = {
		uid     : userData?.userId,
		comid   : userData?.companyId,
		empRole : userData?.empRole,
		role    : userData?.role
	};

	// Handle adding a bookmark
	const handleBookmark = async () =>
	{
		if (stopRef.current || disabled) return;
		stopRef.current = true;

		const body = {
			feedId,
			userData : userInfo(userData)
		};

		try
		{
			const res = await createBookmark(body, query);

			if (res.status)
			{
				setBookMark(true);
				addBookMarkCallback();
				handleFeedAction('append', 'bookmark_add', res?.response);
			}
		}
		catch (err)
		{
			catchErr(err);
		}
		finally
		{
			stopRef.current = false;
		}
	};

	// Handle removing a bookmark
	const handleRemoveBookmark = async (e: React.MouseEvent<SVGElement>) =>
	{
		e.stopPropagation();
		if (stopRef.current) return;
		stopRef.current = true;

		try
		{
			const res = await deleteBookmark(feedId, query);

			if (res.status)
			{
				setBookMark(false);
				handleFeedAction('append', 'bookmark_remove', feedId);
			}
			// eslint-disable-next-line no-console
			else console.error(res);
		}
		catch (err)
		{
			catchErr(err);
		}
		finally
		{
			stopRef.current = false;
		}
	};

	return bookMark
		? (
			<BsBookmarkFill
				onClick={handleRemoveBookmark}
				fontSize='var(--pixel18)'
				color='rgba(83, 100, 113, 1)'
				style={{ cursor: 'pointer' }}
			/>
		)
		: (
			<FaRegBookmark
				onClick={handleBookmark}
				style={
					disabled
						? { display: 'none', pointerEvents: 'none', opacity: 0.5 }
						: { cursor: 'pointer' }
				}
				fontSize='var(--pixel18)'
			/>
		);
};

export default BookMarkButton;
